var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlag1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.50033 18.3333C2.04009 18.3333 1.66699 17.9603 1.66699 17.5V2.50001C1.66699 2.29929 1.73796 2.11514 1.85617 1.97129C1.88195 1.93991 1.90998 1.91046 1.94001 1.88316C2.06827 1.76659 2.23303 1.68946 2.41513 1.67097C2.44313 1.66813 2.47156 1.66667 2.50033 1.66667H17.5003C17.8077 1.66667 18.0901 1.83582 18.2351 2.10679C18.3801 2.37776 18.3642 2.70654 18.1937 2.96226L15.1686 7.50001L18.1937 12.0378C18.3642 12.2935 18.3801 12.6223 18.2351 12.8933C18.0901 13.1642 17.8077 13.3333 17.5003 13.3333H3.33366V17.5C3.33366 17.9603 2.96056 18.3333 2.50033 18.3333Z",
    fill: "#D42124"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag1);
export default __webpack_public_path__ + "static/media/flag1.497195cbad24b194a509f72286ae476a.svg";
export { ForwardRef as ReactComponent };